"use client";

import { useEffect } from "react";

import * as Sentry from "@sentry/nextjs";
import posthog from "posthog-js";

import { clientEnv } from "../../env.client";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("global-error", error);
    Sentry.captureException(error);
    posthog.captureException(error, {
      environment: clientEnv.NEXT_PUBLIC_POSTHOG_ENVIRONMENT,
    });
  }, [error]);

  return (
    <html>
      <body>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
          }}>
          <h2>Something went wrong!</h2>
          <button
            onClick={() => reset()}
            style={{ marginTop: "1rem", padding: "0.5rem 1rem", cursor: "pointer" }}>
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
